module.exports = "<input type=\"checkbox\" #input (change)=\"onChanged($event)\"  [(ngModel)]=\"val\" />\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Grid/yesno.component.html
// module id = 489
// module chunks = 1